export default __webpack_public_path__ + "6e9bce5c0ea53894a60e2dbcd93e97f1.png";